export enum LoginTypeEnum {
  User = 'user',
  Windows = 'windows',
}
